module.exports = __webpack_public_path__ + "static/media/MySQL.b291550f.png";